import styled, {css} from "styled-components"

interface PartialProps {
  size: number
}

export const StyledImage = styled.img<PartialProps>`
  ${({size}) => `
    width: ${size}px;
    height: ${size}px;
  `}
`

export const ImageContainer = styled.div<PartialProps>`
  ${({theme, size}) => css`
    position: absolute;
    top: -${size / 2 + 5}px;
    width: 100%;
    margin-left: ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-left: ${theme.spacing.four};
    `}
  `}
`

export const OuterContainer = styled.div<PartialProps>`
  ${({size}) => `
    width: ${size}px;
  `}
`
